import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearReservationRemoved } from 'Checkout/Redux/Slices/CartSlice'
import AlertDismiss from 'Shared/Alert/AlertDismiss/AlertDismiss'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'

const RemovedAlert = () => {
  const dispatch = useDispatch()
  const reservationRemoved = useSelector(state => state.cart.reservationRemoved)

  useEffect(() => {
    if (reservationRemoved) {
      const timer = setTimeout(() => {
        dispatch(clearReservationRemoved())
      }, 4000)

      return () => clearTimeout(timer)
    }
  }, [reservationRemoved])

  const onDismiss = () => dispatch(clearReservationRemoved())

  return (
    <AlertDismiss className="alert-success" onDismiss={onDismiss}>
      <FontAwesomeIcon className="me-2 text-success" icon="circle-check" size="lg" />
      Reservation has been successfully removed.
    </AlertDismiss>
  )
}

export default RemovedAlert
